<script setup lang="ts">
    const { contactUrl } = useURL();
</script>
<template>
    <nuxt-link
        v-if="contactUrl"
        :to="contactUrl"
        class="atm-contact-button gap-3 text-base transition-colors hover:text-woom-red max-lg:flex max-lg:items-center max-lg:py-3 lg:p-1">
        {{ $t('contact') }}
    </nuxt-link>
</template>
